import { ChartAPIFunctionProps } from '~/types/create.types';
import { getBarColor, mapBars } from '~/utils/time-series';

//TO-DO improve this, might be slow on big domains
export const drawBars = ({
  x,
  y,
  options,
  context,
  timeseries,
  domain,
  data,
}: ChartAPIFunctionProps) => {
  const barSpacing = x.barSpacing;
  const preparedTs = mapBars(timeseries, data, domain);
  const barLineWidth = 1;
  const barWidth = 0.3 * barSpacing;
  const sideWidth = Math.ceil(barWidth * 1.5);

  const drawOpenClose = barLineWidth <= barSpacing && barSpacing >= 1;

  for (const bar of preparedTs) {
    const color = getBarColor(bar, options);
    context.fillStyle = color;

    const xCoord = x.xScale(bar.index);
    const high = y.yScale(bar.high);
    const low = y.yScale(bar.low);
    const barHigh = Math.min(high, low);
    const barLow = Math.max(high, low);

    const bodyCenter = Math.round(xCoord);
    const bodyTop = Math.round(barHigh);
    const bodyBottom = Math.round(barLow);
    const bodyHeight = Math.max(bodyBottom - bodyTop, barLineWidth);
    const bodyLeft = bodyCenter;
    const bodyRight = bodyCenter + barLineWidth - 1;

    context.fillRect(bodyCenter, bodyTop, barLineWidth, bodyHeight);

    if (drawOpenClose) {
      const openLeft = bodyCenter - sideWidth;
      const barOpen = y.yScale(bar.open);
      let openTop = Math.max(bodyTop, Math.round(barOpen));
      let openBottom = openTop + barLineWidth - 1;
      //TO-DO this might not be needed at all, requires double checking
      if (openBottom > bodyTop + bodyHeight - 1) {
        openBottom = bodyTop + bodyHeight - 1;
        openTop = openBottom - barLineWidth + 1;
      }

      context.fillRect(
        openLeft,
        openTop,
        bodyLeft - openLeft,
        openBottom - openTop + 1
      );

      const closeRight = bodyCenter + sideWidth;
      const barClose = y.yScale(bar.close);
      let closeTop = Math.max(bodyTop, Math.round(barClose));
      let closeBottom = closeTop + barLineWidth - 1;
      //TO-DO this might not be needed at all, requires double checking
      if (closeBottom > bodyTop + bodyHeight - 1) {
        closeBottom = bodyTop + bodyHeight - 1;
        closeTop = closeBottom - barLineWidth + 1;
      }

      context.fillRect(
        bodyRight + 1,
        closeTop,
        closeRight - bodyRight,
        closeBottom - closeTop + 1
      );
    }
  }
};
